import { AccessControlListDc, ColumnDescriptionDc, DetailedTableInfoDc, GeometryType } from "@evergis/api";

import { getRandomSymbol } from "react-sgis/symbols/SymbolRenderer/getRandomSymbol";
import { CreateLayerInput } from "resources/layers";
import { LayerAttribute } from "../../../components/Dialogs/EditResource/components/Layer/LayerAttributeItem";
import { ResourceMeta } from "../../../hooks/useResourceMeta";
import { LayerSymbol } from "../../../interfaces/style";
import { getResourceName } from "../../../utils/resourceName";

export type LayerInputConfiguration = ResourceMeta & {
  attributes: PickAndOmit<ColumnDescriptionDc, LayerAttribute, "type" | "srid">[];
  geometryType: ElementType<DetailedTableInfoDc["geometries"]>;
  idField: string;
  titleAttribute?: string;
  name?: string;
  tableName?: string;
  geometryAttribute: Pick<LayerAttribute, "attributeName">;
  minResolution?: number;
  maxResolution?: number;
  acl?: AccessControlListDc;
  filterExpression?: boolean;
  isCogLayer?: boolean;
  srid?: number;
};

type LayerStyle = {
  children: null;
  condition: null;
  symbol: LayerSymbol;
  title: null;
  minResolution?: number;
  maxResolution?: number;
};

type CreateLayerStyleProps = {
  geometryType: GeometryType;
  minResolution?: number;
  maxResolution?: number;
};

export const createLayerStyle = ({
  geometryType,
  minResolution,
  maxResolution,
}: CreateLayerStyleProps): LayerStyle => ({
  title: null,
  children: null,
  condition: null,
  symbol: getRandomSymbol(geometryType),
  minResolution,
  maxResolution,
});

export const createLayerInput = (
  {
    attributes,
    idField,
    geometryType,
    alias,
    titleAttribute,
    name,
    description,
    preview,
    geometryAttribute,
    minResolution,
    maxResolution,
    acl,
    copyrightText,
    isCogLayer,
    tableName,
    srid: layerSrid,
  }: LayerInputConfiguration,
  uniqueTables?: boolean,
): CreateLayerInput => {
  return {
    idAttribute: idField,
    geometryAttribute: geometryAttribute && geometryAttribute.attributeName,
    titleAttribute,
    attributes,
    dataTable: {
      columns: attributes
        .filter(({ expression, sysAttribute }) => (!sysAttribute ? !expression : true))
        .map(({ attributeName, alias: attributeAlias, type, srid, hasIndex }) => ({
          name: attributeName,
          alias: attributeAlias,
          type,
          srid,
          hasIndex,
        })),
      name: uniqueTables ? getResourceName() : tableName || getResourceName(),
      alias,
      description,
      preview: preview && preview.file ? preview.file.name : "",
    },
    style: createLayerStyle({ geometryType, minResolution, maxResolution }),
    acl,
    copyrightText,
    isCogLayer,
    layerName: name || getResourceName(),
    srid: layerSrid,
    geometryType,
  };
};
